// Постоянный архив пройденных/пропущенных задач тренажёра зевков. Тап «Дальше»
// после верного решения (или скип) кладёт задачу сюда по стабильному ключу —
// свои позиции больше не возвращаются в ротацию. Чистые хелперы + тонкая
// обёртка над localStorage (webview/node могут не дать storage → мягкий try/catch).

const ARCHIVE_KEY = 'cc_train_archive';

/** Минимальная форма задачи для вычисления ключа архива. */
export interface ArchiveRef {
  source: 'own' | 'lichess';
  gameId?: string;
  ply?: number;
  parentFen: string;
}

/** Стабильный ключ: свои — `gameId#ply`, пазл Lichess — по FEN. */
export function archiveKeyOf(ref: ArchiveRef): string {
  return ref.source === 'own' && ref.gameId != null && ref.ply != null
    ? `${ref.gameId}#${ref.ply}`
    : `fen:${ref.parentFen}`;
}

/** Прочитать множество архивных ключей (пустое при блокировке/отсутствии storage). */
export function loadArchive(): Set<string> {
  try {
    const raw = localStorage.getItem(ARCHIVE_KEY);
    const arr = raw ? (JSON.parse(raw) as unknown) : [];
    return new Set(Array.isArray(arr) ? arr.filter((x): x is string => typeof x === 'string') : []);
  } catch {
    return new Set();
  }
}

/** Добавить задачу в архив (идемпотентно). */
export function archivePuzzle(ref: ArchiveRef): void {
  const set = loadArchive();
  set.add(archiveKeyOf(ref));
  try {
    localStorage.setItem(ARCHIVE_KEY, JSON.stringify([...set]));
  } catch {
    /* webview may block storage */
  }
}

/** Отфильтровать архивные из списка задач (чистая). */
export function excludeArchived<T extends ArchiveRef>(puzzles: T[], archived: Set<string>): T[] {
  return puzzles.filter((p) => !archived.has(archiveKeyOf(p)));
}
